import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "./api-client";

export type SessionUser = { id: string; username: string };

const SESSION_KEY = ["session"] as const;

export function useSession() {
    return useQuery({
        queryKey: SESSION_KEY,
        queryFn: async (): Promise<SessionUser | null> => {
            try {
                return await api.get<SessionUser>("/api/auth/me");
            } catch (error) {
                // Chưa đăng nhập là trạng thái bình thường, không phải lỗi cần retry.
                if (error instanceof ApiError && error.isUnauthorized) return null;
                throw error;
            }
        },
        retry: false,
        staleTime: 60_000,
    });
}

export function useLogin() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (credentials: { username: string; password: string }) =>
            api.post<SessionUser>("/api/auth/login", credentials),
        onSuccess: (user) => queryClient.setQueryData(SESSION_KEY, user),
    });
}

export function useLogout() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => api.post<{ ok: true }>("/api/auth/logout"),
        onSuccess: () => {
            queryClient.setQueryData(SESSION_KEY, null);
            queryClient.clear();
        },
    });
}
